module.exports = __webpack_public_path__ + "img/mnz_coworking.339999e6.jpg";